/** `SheetContent` classes of a details sheet (client, snippet). */
export const DETAIL_SHEET_CLASS =
  'bg-neutral-ui-bg w-full max-w-none gap-0 rounded-l-xl p-0 sm:max-w-3xl'
